"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = exports.objectKeysMapper = exports.objectKeysToLowerCase = exports.objectKeysToUpperCase = exports.lowerCaseFirstLetter = exports.capitalizeFirstLetter = exports.formatTime = exports.formatDate = exports.formatEmailInput = exports.formatZipCode = exports.formatTimeInput = exports.formatPersonalIdentityNumber = exports.formatPhoneNumberInput = exports.formatOrganizationNumberInput = exports.formatLicensePlateInput = exports.formatDateInput = exports.formatNumberInput = void 0;
const enums_1 = require("../enums");
// @ts-ignore
const number_formatter_1 = __importDefault(require("number-formatter"));
const formatNumberInput = (value, inputType, decimals = 2) => {
    var _a, _b;
    let filtered = (_b = (_a = value === null || value === void 0 ? void 0 : value.replace(/\s/g, '') // Whitespace
    ) === null || _a === void 0 ? void 0 : _a.replace(String.fromCharCode(8722), '-') // Minus sign
    ) === null || _b === void 0 ? void 0 : _b.replace(',', inputType === enums_1.InputType.FLOAT ? '.' : ''); // Decimal separator
    let parsed = inputType === enums_1.InputType.FLOAT ? parseFloat(filtered) : parseInt(filtered);
    if (Number.isNaN(parsed))
        return {
            formatted: '',
            parsed: null,
        };
    let formatted = (0, exports.formatNumber)(parsed, inputType === enums_1.InputType.FLOAT ? decimals : 0);
    if (inputType === enums_1.InputType.FLOAT) {
        // Ends with decimal separator
        if (!filtered.slice(0, -1).includes('.') && filtered.endsWith('.'))
            formatted += ',';
        // Only decimal is zero
        else if (filtered.endsWith('.0'))
            formatted += ',0';
    }
    return {
        formatted,
        parsed,
    };
};
exports.formatNumberInput = formatNumberInput;
/**
 * Format value as a date.
 * If parsing fails, return original value.
 */
const formatDateInput = (value) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let parsedDate = new Date(value);
    let formatted = value, parsed = value;
    if (!Number.isNaN(parsedDate.getTime())) {
        const day = (_c = (_b = (_a = parsedDate.getDate()) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.padStart(2, '0')) !== null && _c !== void 0 ? _c : '';
        const month = (_f = (_e = (_d = (parsedDate.getMonth() + 1)) === null || _d === void 0 ? void 0 : _d.toString()) === null || _e === void 0 ? void 0 : _e.padStart(2, '0')) !== null && _f !== void 0 ? _f : '';
        const year = (_h = (_g = parsedDate === null || parsedDate === void 0 ? void 0 : parsedDate.getFullYear()) === null || _g === void 0 ? void 0 : _g.toString()) !== null && _h !== void 0 ? _h : '';
        formatted = `${day}.${month}.${year}`;
        parsed = `${year}-${month}-${day}`;
    }
    return {
        formatted,
        parsed,
    };
};
exports.formatDateInput = formatDateInput;
const formatLicensePlateInput = (value) => {
    var _a, _b, _c, _d, _e;
    let formatted = '';
    let parsed = (_a = value === null || value === void 0 ? void 0 : value.replace('\xa0', '')) !== null && _a !== void 0 ? _a : null;
    // The first two characters contain a non-letter symbol
    if ((parsed === null || parsed === void 0 ? void 0 : parsed.length) <= 2 && (parsed === null || parsed === void 0 ? void 0 : parsed.match(/[^A-Z-a-z]/g))) {
        parsed = (_c = (_b = parsed === null || parsed === void 0 ? void 0 : parsed.match(/[A-Za-z]/g)) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
    }
    // A number was not entered as the third letter
    if ((parsed === null || parsed === void 0 ? void 0 : parsed.length) === 3 && !(parsed === null || parsed === void 0 ? void 0 : parsed.slice(-1).match(/\d/g))) {
        parsed = parsed.slice(0, -1);
    }
    if ((parsed === null || parsed === void 0 ? void 0 : parsed.length) >= 3) {
        const letterCombination = parsed.slice(0, 2);
        const numberSeries = parsed.slice(2);
        formatted = `${letterCombination}\xa0${numberSeries}`;
    }
    else {
        formatted = parsed;
    }
    return {
        formatted: (_d = formatted === null || formatted === void 0 ? void 0 : formatted.toUpperCase()) !== null && _d !== void 0 ? _d : '',
        parsed: (_e = parsed === null || parsed === void 0 ? void 0 : parsed.toUpperCase()) !== null && _e !== void 0 ? _e : '',
    };
};
exports.formatLicensePlateInput = formatLicensePlateInput;
const formatOrganizationNumberInput = (value) => {
    var _a;
    const parsed = ((_a = value === null || value === void 0 ? void 0 : value.replace(/(\xa0)/g, '')) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9]/g, '')) || null;
    const formatted = parsed
        ? parsed
            .split('')
            .map((char, i) => {
            return (i + 1) % 3 === 0 && i + 1 < parsed.length ? `${char}\xa0` : char;
        })
            .join('')
        : '';
    return {
        formatted,
        parsed,
    };
};
exports.formatOrganizationNumberInput = formatOrganizationNumberInput;
/**
 * Specify whether the country code should be permitted input or not.
 *
 * We only allow Norwegian phone numbers since only they work with "BankID på mobil".
 */
const formatPhoneNumberInput = (value, withCountryCode = false) => {
    var _a, _b, _c, _d;
    // Used for differentiating between adding or removing text
    const separator = withCountryCode ? 'X' : '';
    let removing = false;
    const regex = new RegExp(`[^\\d${separator}${withCountryCode ? '+' : ''}]`, 'g');
    let parsed = (_b = (_a = value === null || value === void 0 ? void 0 : value.replace('\xa0', separator) // Replaces first occurrence
    ) === null || _a === void 0 ? void 0 : _a.replace(/(\xa0)/g, '') // Replaces remaining
    ) === null || _b === void 0 ? void 0 : _b.replace(regex, '');
    let countryCode = '';
    let phoneNumber = parsed !== null && parsed !== void 0 ? parsed : '';
    if (withCountryCode && (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.startsWith('+'))) {
        countryCode = parsed.slice(0, 3);
        phoneNumber = parsed.slice(3).padStart(separator.length, separator);
        // Country code is not Norway
        if ((countryCode.length === 2 && countryCode.slice(-1) !== '4') ||
            (countryCode.length === 3 && countryCode.slice(-1) !== '7')) {
            countryCode = countryCode.slice(0, -1);
            parsed = countryCode;
        }
        // Is the user removing text?
        removing = countryCode.length === 3 && countryCode === '+47' && phoneNumber === separator;
    }
    // Cleanup
    phoneNumber = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(separator, '');
    parsed = parsed === null || parsed === void 0 ? void 0 : parsed.replace(separator, '');
    // Add separators every two digits
    phoneNumber = (_d = (_c = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.split('')) === null || _c === void 0 ? void 0 : _c.map((digit, i) => {
        return (i + 1) % 2 === 0 && i + 1 < phoneNumber.length ? `${digit}\xa0` : digit;
    })) === null || _d === void 0 ? void 0 : _d.join('');
    const formatted = `${countryCode}${countryCode.length === 3 && !removing ? '\xa0' : ''}${phoneNumber}`;
    return {
        formatted: formatted !== null && formatted !== void 0 ? formatted : '',
        parsed: parsed !== null && parsed !== void 0 ? parsed : null,
    };
};
exports.formatPhoneNumberInput = formatPhoneNumberInput;
const formatPersonalIdentityNumber = (value) => {
    var _a;
    const parsed = ((_a = value === null || value === void 0 ? void 0 : value.replace(/(\xa0)/g, '')) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9]/g, '')) || null;
    const birthDate = parsed === null || parsed === void 0 ? void 0 : parsed.slice(0, 6);
    const checkDigits = parsed === null || parsed === void 0 ? void 0 : parsed.slice(6);
    const formatted = `${birthDate ? birthDate : ''}${checkDigits ? '\xa0' + checkDigits : ''}`;
    return {
        formatted: formatted !== null && formatted !== void 0 ? formatted : '',
        parsed: parsed !== null && parsed !== void 0 ? parsed : null,
    };
};
exports.formatPersonalIdentityNumber = formatPersonalIdentityNumber;
/**
 * Format time with a colon as a separator.
 * We do not include the seconds component.
 */
const formatTimeInput = (value) => {
    var _a, _b;
    const [hour, minute] = (_b = (_a = value === null || value === void 0 ? void 0 : value.split(':')) === null || _a === void 0 ? void 0 : _a.map((value, i) => value.match(/\d+/g)
        ? Math.min(parseInt(value), i === 0 ? 23 : 59)
            .toString()
            .padStart(2, '0')
        : '')) !== null && _b !== void 0 ? _b : ['', ''];
    const formatted = hour ? `${hour.length >= 2 ? hour + ':' : hour}${minute ? minute : ''}` : '';
    const parsed = formatted || '';
    return {
        formatted,
        parsed,
    };
};
exports.formatTimeInput = formatTimeInput;
const formatZipCode = (value) => {
    var _a;
    const parsed = ((_a = value === null || value === void 0 ? void 0 : value.match(/\d+/g)) === null || _a === void 0 ? void 0 : _a.toString()) || '';
    const formatted = parsed;
    return {
        formatted,
        parsed,
    };
};
exports.formatZipCode = formatZipCode;
const formatEmailInput = (value) => {
    var _a, _b;
    let parsed = (_b = (_a = value === null || value === void 0 ? void 0 : value.replace(/(\w+)@+(\w*)/, '$1@$2') // Multiple @ symbols
    ) === null || _a === void 0 ? void 0 : _a.replace(/(\w+@\w+)\.+/, '$1.')) !== null && _b !== void 0 ? _b : ''; // Multiple periods
    const formatted = parsed;
    return {
        formatted,
        parsed,
    };
};
exports.formatEmailInput = formatEmailInput;
const formatDate = (timestamp) => {
    if (timestamp === null)
        return;
    let td = new Date(timestamp);
    let date = td.getDate().toString();
    if (date.length === 1) {
        date = `0${date}`;
    }
    let month = (td.getMonth() + 1).toString();
    if (month.length === 1) {
        month = `0${month}`;
    }
    let year = td.getFullYear().toString();
    return date + '.' + month + '.' + year;
};
exports.formatDate = formatDate;
const formatTime = (timestamp, includeSeconds = true) => {
    if (timestamp === null)
        return null;
    const td = new Date(timestamp);
    const hours = td.getHours() < 10 ? `0${td.getHours()}` : td.getHours();
    const minutes = td.getMinutes() < 10 ? `0${td.getMinutes()}` : td.getMinutes();
    const seconds = td.getSeconds() < 10 ? `0${td.getSeconds()}` : td.getSeconds();
    return `${hours}:${minutes}:${seconds}`;
};
exports.formatTime = formatTime;
const capitalizeFirstLetter = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
const lowerCaseFirstLetter = (text) => {
    return text.charAt(0).toLowerCase() + text.slice(1);
};
exports.lowerCaseFirstLetter = lowerCaseFirstLetter;
const objectKeysToUpperCase = (input) => {
    return (0, exports.objectKeysMapper)(input, exports.capitalizeFirstLetter);
};
exports.objectKeysToUpperCase = objectKeysToUpperCase;
const objectKeysToLowerCase = (input) => {
    return (0, exports.objectKeysMapper)(input, exports.lowerCaseFirstLetter);
};
exports.objectKeysToLowerCase = objectKeysToLowerCase;
const objectKeysMapper = (input, mapperFunction) => {
    if (!input || typeof input !== 'object') {
        return input;
    }
    if (Array.isArray(input)) {
        return input.map((val) => (0, exports.objectKeysMapper)(val, mapperFunction));
    }
    return Object.keys(input).reduce((newObj, key) => {
        const val = input[key];
        newObj[mapperFunction(key)] = !!val && typeof val === 'object' ? (0, exports.objectKeysMapper)(val, mapperFunction) : val;
        return newObj;
    }, {});
};
exports.objectKeysMapper = objectKeysMapper;
// TODO: Deprecated
const formatNumber = (num, fractionDigits = 0) => {
    if (typeof num !== 'number')
        return num;
    return (0, number_formatter_1.default)('### ##0,##', parseFloat(num.toFixed(fractionDigits)));
};
exports.formatNumber = formatNumber;
//# sourceMappingURL=formatters.js.map